import { RadioTileGroup } from '@noissue-ui-kit/oldBranding/radioTile'
import React from 'react'

export function ColorButton({
  color,
  showColorSetting,
  setShowColorSetting,
}: {
  key: string
  color: string
  showColorSetting: boolean
  setShowColorSetting: (boolean) => void
}) {
  const radioTileButtonOption = {
    displayLabel: (
      <div
        className="flex w-[24px] h-[24px] rounded-full m-0 border-2 border-core-grey-20"
        style={{ backgroundColor: color }}
      />
    ),
    key: 'color',
  }

  return (
    <>
      <RadioTileGroup
        onChange={setShowColorSetting}
        options={[radioTileButtonOption]}
        radioGroupClassName="grid-cols-1 w-full sm:w-auto grow md:max-w-[100px]"
        selected={showColorSetting ? { ...radioTileButtonOption } : null}
        radioItemClassName="hover:bg-black-10"
      />
    </>
  )
}
